// @flow

import React from 'react';

const PageNotFound = () => {
    return <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        flexDirection: 'column'
    }}>
        Page not found
    </div >;
};

export default PageNotFound;